import { render, staticRenderFns } from "./travelList.vue?vue&type=template&id=5218adc2&scoped=true"
import script from "./travelList.vue?vue&type=script&lang=js"
export * from "./travelList.vue?vue&type=script&lang=js"
import style0 from "./travelList.vue?vue&type=style&index=0&id=5218adc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5218adc2",
  null
  
)

export default component.exports